import { useFlags } from './amplitude/client';
import { Flags } from './flagConstants';
import { isMultiCartEnabled } from './multiCart';

/** Client-component gate for the multi-product cart rollout (CPS-7479). */
export const useMultiCart = (): { enabled: boolean; loading: boolean } => {
  const { flags, loading } = useFlags();
  return { enabled: isMultiCartEnabled(flags?.[Flags.MULTI_CART]), loading };
};
